module.exports = __webpack_public_path__ + "img/wifi-warning.6fa21cdd.svg";